import { Button, Dialog, DialogBody, Input, Typography } from '@material-tailwind/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { loginConfirmCode, sendRefresh, sendRefreshFinish } from '../../store/auth/authActions';
import { AppDispatch, RootState } from '../../store/store';
import { createPortal } from 'react-dom';
import CloseDrawerIcon from '../../images/icons/CloseDrawerIcon';
import { successToast } from '../toasts/toasts';
import { useSelector } from 'react-redux';
import { clearErrorsLoginConfirm, setToken } from '../../store/auth/authSlice';
import { useNavigate } from 'react-router-dom';


const ConfirmCodeForm = (props: {
    open: boolean,
    handleClose: any
    modalValue: {
        email: string
        jwt: string
    } | null
}) => {

    const navigate = useNavigate()

    const { open, handleClose, modalValue } = props
    const { t } = useTranslation()

    const dispatch = useDispatch<AppDispatch>()
    const { loadingConfirm, errorConfirm } = useSelector((state: RootState) => state.auth)

    // const [isCodeEnterMode, setIsCodeEnterMode] = useState<boolean>(false);

    // const [emailValue, setEmailValue] = useState('');
    const [codeValue, setCodeValue] = useState('');

    const handleConfirmCode = () => {
        if (!modalValue) return
        dispatch(loginConfirmCode({
            code: codeValue,
            jwt: modalValue.jwt,
            email: modalValue.email,
            lang: 'ua'
        }))
            .then((res) => {
                if (res?.payload?.res === 'Success') {
                    dispatch(setToken(modalValue.jwt))
                    localStorage.setItem('userToken', modalValue.jwt)
                    navigate('/', { replace: true });
                }
            }).catch(err => {
                console.log(err)
            })
    }


    // const handleConfirmCode = () => {
    //     dispatch(sendRefreshFinish({
    //         email: emailValue,
    //         code: codeValue,
    //         lang: 'ua'
    //     }))
    //         .then((res) => {
    //             if (res?.payload?.res === 'Success') {
    //                 successToast({ title: t('auth.success_on_code_confirm') })
    //                 setIsCodeEnterMode(false)
    //                 setEmailValue('')
    //                 setCodeValue('')
    //                 handleClose()
    //             }
    //         });
    // }

    const handleClearError = () => {
        dispatch(clearErrorsLoginConfirm())
    }

    const onClose = () => {
        handleClearError()
        setCodeValue('')
        handleClose()
    }

    return (
        createPortal(
            <>
                <Dialog open={open} handler={onClose} className='!min-w-0 !max-w-[640px] bg-white p-[24px] tab:p-[32px] rounded-[16px] '>
                    <DialogBody className="p-0">
                        <div className="flex items-center justify-between mb-[32px]">
                            <Typography variant="lead" className="text-[18px] lap:text-[24px] text-gray-800 font-medium ">
                                {t('auth.confirm_code_text')}
                            </Typography>
                            {/* <div onClick={handleClose} className="rounded-full w-[32px] h-[32px] transition-all flex items-center justify-center active:bg-gray-200 hover:bg-gray-100 cursor-pointer">
                                <CloseDrawerIcon />
                            </div> */}
                        </div>
                        <div className='w-full'>
                            <Typography variant="lead" className="text-[14px] leading-[1.2] lap:text-[20px] text-gray-800 my-[32px] ">
                                {t('auth.confirm_text_paragraph')}
                            </Typography>
                            <div className='mb-[30px]'>
                                <Input
                                    value={codeValue}
                                    onChange={(e) => {
                                        setCodeValue(e.target.value)
                                        handleClearError()
                                    }}
                                    variant='static'
                                    type={'text'}
                                    placeholder={t('auth.confirm_code_placeholder')}
                                />
                            </div>
                            <Typography variant='lead' className='flex items-center justify-center font-medium text-[14px] text-center text-red-500 min-h-[32px] mt-[16px]'>
                                {errorConfirm ? t(`auth.${errorConfirm}`) : ' '}
                            </Typography>
                            <Button
                                disabled={codeValue.length < 8}
                                loading={loadingConfirm}
                                color='black'
                                className='font-normal rounded-full text-[18px] w-full py-[20px] flex justify-center'
                                onClick={handleConfirmCode}
                            >
                                {t('auth.confirm_code_btn')}
                            </Button>
                            <Button
                                color='white'
                                className='whitespace-nowrap font-normal rounded-full border-2 text-[18px] w-full mt-[16px]'
                                onClick={onClose}
                            >
                                {t('cancel')}
                            </Button>
                        </div>
                    </DialogBody>
                </Dialog>
            </>,
            document.getElementById('root')!
        )
    )
}

export default ConfirmCodeForm
